import {
    queryStringParam,
    getCollectionIdFromQueryString,
    getEffectiveAuthTicket,
    getQueryParam
} from './SFMP.MiniUtility.js';

/**
 * @param {string} presentationId
 * @param {string} url
 */
export function appendAuthTicket(presentationId, url) {
    if (!url) {
        // Garbage in -- garbage out.
        return url;
    }

    var connector, collectionId, ticket;
    var fixed = url;

    function getConnector() { return (fixed.indexOf("?") > -1) ? "&" : "?" }

    collectionId = getCollectionIdFromQueryString();
    ticket = getEffectiveAuthTicket(presentationId, collectionId);

    if (!ticket) {
        ticket = getQueryParam(queryStringParam.AUTHTICKET);
    }

    if (ticket) {
        fixed += getConnector() + queryStringParam.AUTHTICKET + "=" + ticket;
    }

    return fixed;
}
